import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import { DashboardStore } from "../../views/dashboard/domain/dashboard.model";




export const fetchDrumData =
    createAsyncThunk<any[], void>("dashboard/fetchDrumData",
        async () => {
            const url = `${AppConstants.api}/drums?page=1&size=1000&testStatuses=TEST_CREATED,TEST_STARTED`
            const response = await api.get<any>(url)
            return response.data.content || []
        })


export const deleteDrumData =
    createAsyncThunk<any[], string>("dashboard/fetchDrumData",
        async (drumId) => {
            const url = `${AppConstants.api}/drums/${drumId}`
            const response = await api.delete<any>(url)
            return response.data.content || []
        })



const initialState: DashboardStore = {
    minimal: {
        status: "idle", error: null, data: [],
    },
};

const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDrumData.pending, (state) => {
                state.minimal.status = "loading";
                state.minimal.data = [];
                state.minimal.error = null;
            })
            .addCase(fetchDrumData.fulfilled, (state, action) => {
                state.minimal.status = "idle";
                state.minimal.data = action.payload ?? [];
                state.minimal.error = null;
            })
            .addCase(fetchDrumData.rejected, (state, action) => {
                state.minimal.status = "failed";
                state.minimal.data = [];
                state.minimal.error = action.payload as string;
            })
           
    },
});

export default dashboardSlice.reducer;
